// App.js
import React, { useState, useEffect, useRef } from "react";
import "./App.scss";
import logo from "./assets/images/Auskaup_logo-01.png";
import { Logo } from "./components/Logo";
import hero from "./assets/images/hero.jpg";
import BGGray from "./assets/images/bg_gray.jpg";
import BGGray2 from "./assets/images/bg_gray2.jpg";
import BGRed from "./assets/images/bg_red.jpg";
import BGRedText from "./assets/images/bg_red_text.jpg";
import MaksuMark from "./assets/images/Maksumärk.JPG";
import PunaneKarp from "./assets/images/Punane_karp_2.png";
import PunaneKarp3 from "./assets/images/Punane_karp_3.png";
import KodaLogo from "./assets/images/KODA_EST_logo_horiz+tag.svg";
import KodaLogoWhite from "./assets/images/KODA_EST_logo_horiz+tag_white.svg";

import ValgeKarp from "./assets/images/Valge_karp_maksumärk.png";
import ValgeKarp3 from "./assets/images/Valge_karp_3.png";

import Grid from "./components/Grid";

import BoxesRed from "./assets/images/boxes_ref.png";
import BoxesWhite from "./assets/images/boxes_white.png";
import Pointer from "./assets/images/pointer.svg";
import Modal from "./components/Modal";

function App() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [scrollPositionY, setScrollPositionY] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalType, setModalType] = useState("default");

  const diagramRef = useRef(null);
  const leftPolygonsRef = useRef(null);
  const rightPolygonsRef = useRef(null);

  if (isMenuOpen) {
    document.body.classList.add("dontScroll");
  } else {
    document.body.classList.remove("dontScroll");
  }
  const openModal = (type) => {
    setModalType(type);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  useEffect(() => {
    const handleScroll = () => {
      window.requestAnimationFrame(() => {
        const scrollY = window.scrollY || document.documentElement.scrollTop;
        setScrollPositionY(scrollY);
      });

      if (diagramRef.current) {
        const rect = diagramRef.current.getBoundingClientRect();
        const isInView = rect.top < window.innerHeight && rect.bottom >= 0;

        if (isInView) {
          diagramRef.current.classList.add("animate");
        } else if (rect.top > window.innerHeight) {
          diagramRef.current.classList.remove("animate");
        }
      }

      if (leftPolygonsRef.current) {
        const rect = leftPolygonsRef.current.getBoundingClientRect();
        const isInView = rect.top < window.innerHeight * 0.8;
        if (isInView) {
          leftPolygonsRef.current.classList.add("slide-in");
        }
      }

      if (rightPolygonsRef.current) {
        const rect = rightPolygonsRef.current.getBoundingClientRect();
        const isInView = rect.top < window.innerHeight * 0.8;
        if (isInView) {
          rightPolygonsRef.current.classList.add("slide-in");
        }
      }
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll();

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const nav = (id = "1") => {
    setIsMenuOpen(false);
    const element = document.getElementById(id);
    element.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className="App">
      <header className="topbar" style={{ backgroundImage: `url(${BGGray})` }}>
        <div className="container">
          <div className={`logo ${isMenuOpen ? "logo-open" : ""}`}>
            <Logo />
          </div>
          <nav className={`nav ${isMenuOpen ? "open" : ""}`}>
            <button onClick={() => nav("1")} type="button">
              Andmed
            </button>
            <button onClick={() => nav("2")} type="button">
              Salaturu kahju
            </button>
            <button onClick={() => nav("4")} type="button">
              Ühiskondlik mõju
            </button>
            <button onClick={() => nav("3")} type="button">
              Üleskutse
            </button>
          </nav>

          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className={`hamburger hamburger--spin ${isMenuOpen ? "is-active" : ""}`}
            type="button"
            aria-label="Menu"
            aria-controls="navigation"
          >
            <span className="hamburger-box">
              <span className="hamburger-inner"></span>
            </span>
          </button>
        </div>
      </header>
      {/* Hero Section */}
      <section className="hero" style={{ backgroundImage: `url(${hero})` }}>
        <div className="hero-overlay">
          <div className="container">
            <h1 className="hero-title">
              E-sigarettide must turg ohustab ausat kaubandust Eestis
            </h1>
            <div className="hero-content">
              <div className="hero-row">
                <p class="drop-cap-paragraph">
                  Eesti Kaubandus-Tööstuskoda koos oma partneritega juhib
                  <strong> AUS KAUP. AUS MÄNG</strong> kampaaniaga tähelepanu
                  e-sigarettide musta turu laiaulatuslikule levikule Eestis.
                  Tegemist on ühiskondliku probleemiga, kus ebaseaduslikud
                  tooted liiguvad kontrollimatult ning on alaealistele lihtsasti
                  kättesaadavad. Must turg süvendab reeglitest möödahiilimist
                  ning selle mõjud tabavad sageli enim neid, kes vajavad rohkem
                  kaitset – noori. Vastutustundlikud ettevõtted ei tegele
                  salakaubandusega ning ootavad riigilt võrdselt kehtivaid
                  mängureegleid. Probleemi tõkestamisel on olulisel kohal
                  koostööpõhise järelevalve jätkuv edendamine, eriti
                  ennetusfaasis. Koondades ettevõtjaid üle Eesti, kutsub
                  Kaubandus-Tööstuskoda valitsust üles kinnistama tõhusaid
                  meetmeid, et kaitsta läbipaistvat majanduskeskkonda ja
                  turvalist kaubandust Eestis.
                </p>
              </div>
              <div className="hero-columns">
                <div className="hero-column">
                  <h3 className="text-centered clickable">
                    <a
                      className="underline"
                      href="https://www.koda.ee/sites/default/files/2026-02/30.01.2026%20E-sigarettide%20musta%20turu%20ohjeldamine.pdf"
                      target="_blank"
                      rel=""
                    >
                      Loe Kaubandus-Tööstuskoja avalikku pöördumist valitsusele
                    </a>
                  </h3>
                </div>
               
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Special Section */}

      <section
        id="1"
        className="special-section"
        style={{ backgroundImage: `url(${BGGray2})`, position: "relative" }}
      >
        <Grid scrollPositionY={scrollPositionY} />

        <div
          className="container"
          style={{ zIndex: "2", position: "relative" }}
        >
          <h2 className="huge">
            Kui suur on <br />
            salaturg Eestis?
          </h2>
          <div className="numbers-grid">
            <div className="number-item">
              <div className="big-number" onClick={() => openModal("info")}>
                52%
                <span>Kliki numbril ja loe rohkem</span>
                <img className="pointer" src={Pointer} alt="vajuta siia" />
              </div>
            </div>
            <div className="number-item">
              <div className="big-number" onClick={() => openModal("info2")}>
                70%
                <span>Kliki numbril ja loe rohkem</span>
                <img
                  className="pointer"
                  src={Pointer}
                  alt="vajuta siia"
                  style={{ animationDelay: "1s" }}
                />
              </div>
            </div>
          </div>

          <div
            className="diagram"
            ref={diagramRef}
            onClick={() => openModal("info4")}
          >
            <div className="diagram-bar" data-value="386  liitrit">
              <span>2022</span>
            </div>
            <div className="diagram-bar" data-value="780 liitrit">
              <span>2023</span>
            </div>
            <div className="diagram-bar" data-value="3800 liitrit">
              <span>2024</span>
            </div>
            <div className="diagram-bar" data-value="1000 liitrit">
              <span>2025</span>
            </div>
          </div>
          <div style={{ display: "flex", justifyContent: "center" }}>
            <button
              style={{ margin: "0 auto 2rem auto" }}
              className="button-primary"
              onClick={() => openModal("info4")}
            >
              Loe e-sigareti vedelike konfiskeerimise kohta
            </button>
          </div>
          <p
            className="text-center"
            style={{
              display: "flex",
              flexDirection: "column",
              lineHeight: "1.5",
            }}
          >
            <strong>
              {" "}
              <br />
              52% toodetest ei vastanud kehtivatele nõuetele tühjapaki uuringu
              põhjal
              <br />
              70 % e-sigaretti tarvitanud koolinoortest alustas 12-14 aastaselt
              <br />
              ~1000 liitrit e-sigareti vedelikke konfiskeeris Maksu- ja
              Tolliameti 2025. aastal
            </strong>
          </p>
        </div>
      </section>
      {/* Single Column Section */}
      <section
        id="2"
        className="section whiteText"
        style={{ backgroundImage: `url(${BGRed})` }}
      >
        <div className="container">
          <div className="content-center" style={{ maxWidth: "840px" }}>
            <h1 className="margin-bottom">Avalik pöördumine</h1>
            <div className="columns-3 text-left">
              <div className="column">
                <h3>Probleem:</h3>
                <p>
                  E-sigarettide must turg õõnestab läbipaistvat
                  majanduskeskkonda ja ausaid kaubandustavasid ning võimaldab
                  alaealistel pääseda ligi ebaseaduslikele toodetele.
                </p>
              </div>{" "}
              <div className="column">
                <h3>Lahendus:</h3>
                <p>
                  Musta turu tõkestamine eeldab terviklikku ja järjekindlat
                  riiklikku sekkumist, ka ennetusfaasis. Osapooltel on selge
                  ühine vastutus ning järelevalvele on jätkuvalt tagatud
                  piisavad volitused ja mõjusad kontrollmehhanismid.
                </p>
              </div>{" "}
              <div className="column">
                <h3>Ootus riigile:</h3>
                <p>
                  Toetada koostööpõhise järelevalvemudeli jätkuvat edendamist,
                  kus tõhusa sekkumise kõrval on oluline koht ka ennetusel.
                </p>
              </div>
            </div>
            <p>
              <br />
              Kaubandus-Tööstuskoda seisab seaduskuuleka ja vastutustundliku
              ettevõtluse eest.
              <br /> <br /> <br />{" "}
            </p>
            <h1 className="margin-bottom">
              Eesti Kaubandus-Tööstuskoja ettepanekud ja lahendused
            </h1>
            <div className="columns-3 text-left">
              <div className="column">
                <p>
                  <strong> 1. </strong>Koostööpõhise järelevalvemudeli
                  prioriseerimine ja jätkuv edendamine, sh selleks vajalike
                  ressursside tagamisega{" "}
                </p>
              </div>{" "}
              <div className="column">
                <p>
                  <strong> 2. </strong>Seadusandlikes protsessides senisest
                  suurema tähelepanu pööramine musta turu ennetamisele{" "}
                </p>
              </div>{" "}
              <div className="column">
                <p>
                  <strong> 3. </strong>Ettevõtjate teadlikkuse tõstmine
                  vastutustundlikust kaubandusest ja vastutusest{" "}
                </p>
              </div>
            </div>

            <div className="flex-edge margin">
              <img src={KodaLogoWhite} alt="Kaubandus koda" />
              <button>
                <a
                  type="button"
                  className="button button-primary"
                  href="https://www.koda.ee/sites/default/files/2026-02/30.01.2026%20E-sigarettide%20musta%20turu%20ohjeldamine.pdf"
                  target="_blank"
                  rel=""
                >
                  {" "}
                  Loe avalikku pöördumist valitsusele
                </a>
              </button>
            </div>

            <br />
            <i>
              "Usaldus on habras: salakaubandus haavab nii ausat ettevõtlust kui
              ka lõhub ühiskondlikku usaldust vastutustundliku kaubanduse
              vastu." Mait Palts, Eesti Kaubandus-Tööstuskoja peadirektor
            </i>
          </div>
        </div>
      </section>
      {/* Slogan Section */}
      <section
        className="section slogan-section"
        style={{ backgroundImage: `url(${BGGray})` }}
      >
        <div className="container">
          <div>
            {" "}
            <h2
              style={{
                maxWidth: "640px",
                textAlign: "center",
                margin: "0 auto",
              }}
            >
              Ebaseaduslik kaubandus ei ole üksikute reeglite rikkumine, vaid
              mitmetahuline probleem, mis mõjutab kogu ettevõtluskeskkonda. Must
              turg kahjustab majandust ja moonutab konkurentsi, vähendades
              seeläbi ühiskondlikku usaldust ning riigi maksutulu.
            </h2>
            <br />
            <br />
          </div>
          <div className="columns-3">
            <div className="column">
              <h3>1. Ebaaus mänguväli:</h3>
              <p>
                Isikud, kes müüvad seadusele mittevastavaid tooteid või
                vahendavaid neid läbi illegaalsete müügikanalite, saavad
                ebaõiglase hinna ning konkurentsieelise ja lõhuvad läbipaistvat
                ettevõtluskeskkonda. Ausad ettevõtjad, kes järgivad seadusi ja
                kannavad kõiki kulusid, satuvad seetõttu ebavõrdsesse olukorda.
              </p>
            </div>
            <div className="column">
              <h3>2. Usaldus ja maine:</h3>
              <p>
                Kui turul levivad seadusele mittevastavad tooted, kannatab kogu
                sektori maine. Avalikkuse usaldus väheneb ning vastutustundlikud
                ettevõtted peavad tegelema kahtluste ja mainekahjuga.
              </p>
            </div>
            <div className="column">
              <h3>3. Investeeringud ja maksutulu:</h3>
              <p>
                 Must turg vähendab riigi maksulaekumisi ja pidurdab
                investeeringuid. Kui reegleid ei järgita, kaotavad lõpuks kõik –
                riik ja seadusekuulekad ettevõtjad.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section
        id="2"
        className="section whiteText"
        style={{ backgroundImage: `url(${BGRed})` }}
      >
        <div className="container" style={{ maxWidth: "640px" }}>
          <div
            className="flex-edge "
            style={{
              flexDirection: "column",
              gap: "1rem",
              textAlign: "center",
            }}
          >
            <h4>
              <strong>
                “On oluline, et toimiks ühiskondlik koostöö, et me mõistaks ja
                sotsiaalselt ei aksepteeriks illegaalset turgu.”
              </strong>
            </h4>
            <p>Raigo Uukkivi, Maksu- ja Tolliameti peadirektor</p>
          </div>
        </div>
      </section>

      <section
        className="section slogan-section"
        style={{ backgroundImage: `url(${BGGray2})` }}
      >
        <div className="container1 content-center">
          <div className="badge">
            <h1>Salaturu mõju ja kahju</h1>
            <br />
            <br />
            <h3>
              Eestis on lubatud turustada üksnes nõuetele vastavaid e-sigarette,
              millelt on aktsiis tasutud ning mis on müügil seaduslikes
              müügikanalites.{" "}
            </h3>
            <h3>
              Seadusliku e-sigareti tunned ära pakendil oleva maksumärgi järgi.
            </h3>
            <img src={MaksuMark} alt="Maksumärk" />
          </div>
          <div
            style={{
              width: "100%",
              alignItems: "center",
              justifyContent: "center",
              display: "flex",
              marginBottom: "3rem",
            }}
          >
            <button
              type="button"
              className="button-primary"
              onClick={() => openModal("info3")}
            >
              Loe, mis on seadusega määratud
            </button>
          </div>
          <h3>
            Seaduslik kaubandus ei kaitse ainult ausat ettevõtlust – see kaitseb
            ka alaealisi. Mustal turul puuduvad reeglid ja vastutus ning keegi
            ei taga, kellele ja mida müüakse
          </h3>
        </div>
      </section>
      {/* Section with Left Polygons */}
      <section
        id="4"
        className="section polygons-left-section whiteText"
        style={{ backgroundImage: `url(${hero})` }}
      >
        <div className="polygons-left" ref={leftPolygonsRef}>
          <img className="polyimg" src={BoxesRed} />
        </div>
        <div className="container2">
          <div className="content-center addGaps">
            <h1>See pole sulle!</h1>
            <p>
              Must turg ei ole noore jaoks „lihtsalt ost“ - diilereid ei huvita
              ostja vanus ega ohutus. Järjekindel järelevalve ja ühine vastutus
              aitavad tagada, et ebaseaduslikud ja kontrollimata tooted ei jõua
              alaealisteni.
            </p>
            <h3>Mida teha, kui näed müüki alaealisele?</h3>
            <p>
              Kui märkad, et e-sigarette müüakse alaealisele või toimub muu
              ebaseaduslik müük, anna sellest märku EMTA vihjeliinile. Iga vihje
              aitab vähendada musta turgu ja kaitsta noori.
            </p>

            <a
              href="https://www.emta.ee/eraklient/amet-uudised-ja-kontakt/kontaktid/vihje-andmine"
              target="_blank"
              type="button"
              className="button button-primary"
            >
              Anna vihje ebaausast müügist MTAle
            </a>
          </div>
        </div>
      </section>
      {/* Section with Right Polygons */}
      <section
        className="section polygons-right-section"
        style={{ backgroundImage: `url(${BGGray})`, display: "none" }}
      >
        <div className="polygons-right" ref={rightPolygonsRef}>
          <img className="polyimg" src={BoxesWhite} />
        </div>
        <div className="container2 addGaps">
          <h1 className="text-center">
            Eesti Kaubandus-Tööstuskoja ettepanekud ja lahendused
          </h1>
          <div className="columns-3">
            <div className="column">
              <h3>
                Seada riigi jätkuvaks prioriteediks koostööpõhise
                järelevalvesüsteemi edendamine
              </h3>
            </div>
            <div className="column">
              <h3>
                Pöörata rohkem tähelepanu seadusandlikes protssesides musta turu
                ennetamisele
              </h3>
            </div>
            <div className="column">
              <h3>
                Suurendada ettevõtjate teadlikkust vastutustundlikust
                kaubandusest ja võimalikust vastutusest
              </h3>
            </div>
          </div>
          <div className="columns-3">
            <div></div>
            <div className="column">
              <h3>
                Toetada ja arendada ausa turu põhimõtteid, sealhulgas
                vastutustundliku kaubanduse kava loomine
              </h3>
            </div>
          </div>
          <div className="button-row">
            <a href="#" type="button" className="button-primary">
              Lae alla dokument
            </a>
          </div>
        </div>
      </section>
      {/* Call to Action 
      polygons-right-section
      
       <div className="polygons-right" ref={rightPolygonsRef}>
          <img className="polyimg" src={BoxesWhite} />
        </div>
      */}
      <section
        id="3"
        className="section "
        style={{ backgroundImage: `url(${BGGray})` }}
      >
        <div className="container">
          <div className="content-center felxColumn">
            <h2>
              Kutsume valitsust ja Riigikogu üles tegema otsustavaid samme
              kaitsta noori ja pidurdada musta turu levikut.
            </h2>
            <a
              className="button-primary"
              style={{ margin: "0 auto" }}
              href="https://www.koda.ee/sites/default/files/2026-02/30.01.2026%20E-sigarettide%20musta%20turu%20ohjeldamine.pdf"
              target="_blank"
              rel="noopener noreferrer"
            >
              Loe avallikku pöördumist valitsusele
            </a>
            <p>
              <strong>
                Vastutustundlik kaupleja järgib hea tava põhimõtteid, et
                alaealisteni ei jõuaks neile keelatud tooted.
              </strong>
            </p>
            <button
              type="button"
              className="button-primary"
              onClick={() => openModal("info6")}
            >
              Tutvu hea tavaga
            </button>
            <p>
              <strong>
                Kui märkad loata müüki, keelatud tooteid või tead kavandatavast
                salaveost, anna sellest teada!
              </strong>
            </p>

            <a
              className="button-primary"
              style={{ margin: "0 auto" }}
              href="https://www.emta.ee/eraklient/amet-uudised-ja-kontakt/kontaktid/vihje-andmine"
              target="_blank"
              rel="noopener noreferrer"
            >
              Anna vihje ebaausast müügist MTAle
            </a>
            <p>
              Oluline vihje andmisel: Vihje saab anda anonüümselt.
              <br />
              Vihjes tuleks võimalikult täpselt kirjeldada toimepandud või
              kavandatava õigusrikkumise asjaolusid, aega ja kohta.
              <br />
              Vihjete menetlemise ja selle tulemuste kohta tagasisidet ei
              anta.{" "}
            </p>
          </div>
        </div>
      </section>
      {/* Footer */}
      <footer className="footer" style={{ backgroundImage: `url(${BGRed})` }}>
        <div className="container2">
          <div className="footer-columns">
            <div className="footer-column">
              <Logo className="footer-logo" />
            </div>

            <div className="footer-column">
              <img
                className="footer-logo"
                src={KodaLogoWhite}
                alt="footer logo"
              />
            </div>
            <div className="footer-column footer-info">
              <h4>Kontakt:</h4>
              <a href="tel:+372 604 0060">+372 604 0060</a>
              <a href="mailto:koda@koda.ee">koda@koda.ee</a>
            </div>
          </div>
          <p
            style={{
              color: "#FFFFFF99",
              textAlign: "center",
              fontWeight: "600",
              fontSize: "12px",
              fontStyle: "italic",
              margin: "2rem auto",
            }}
          >
            Kampaania on ellu kutsutud e-sigarettide salaturu leviku
            teadvustamiseks ning tähelepanu juhtimiseks selle laiemale
            ühiskondlikule mõjule, et mustal turul on keelatud tooted
            kättesaadavad ka alaealistele. Kampaania eesmärk on toetada
            järelevalve ja institutsionaalse koostöö edendamist ning rõhutada
            ennetustegevuste rolli musta turu tõkestamisel, et tagada aus ja
            turvaline kaubanduskeskkond. Kampaaniat aitavad ellu viia Eesti
            Maksu- ja Tolliamet ning Philip Morris Eesti.
          </p>
        </div>
      </footer>
      {modalType === "info" && (
        <Modal isOpen={isModalOpen} onClose={closeModal} title="">
          <div>
            <p>
              Salaturu osakaalu andmed pärinevad Paesüldi (2025) lõputööst.
              Tühja paki uuringu tulemused näitasid, et 52% Eestis vaadeldud
              toodetest ei vastanud kehtivatele nõuetele (maitse, maht ja/või
              nikotiinisisaldus). Lisaks tunnistas ankeetküsitluses 60%
              e-sigarette tarbinud vastanutest, et tarvitab regulaarselt
              keelatud maitsetega tooteid, mis viitab ulatuslikule salaturu
              levikule Eestis.
            </p>
            <i>
              {" "}
              Allikas: Paesüld, Sigrid (Sisekaitseakadeemia, 2025). „Eestis
              keelatud ühekordsete e-sigarettide leviku hindamine Nicorex Baltic
              OÜ tühja paki uuringu näitel.“
            </i>
          </div>
        </Modal>
      )}
      {modalType === "info2" && (
        <Modal isOpen={isModalOpen} onClose={closeModal} title="">
          <div>
            <p>
              70 % e-sigaretti tarvitanud koolinoortest alustas 12-14 aastaselt.
              Andmed pärinevad Tervise Arengu Instituudi poolt koolinoorte seas
              läbi viidud ESPAD-uuringust. Uuringu kohaselt alustas 70%
              15–16-aastastest noortest, kes olid e-sigarette tarvitanud, nende
              kasutamist juba 12–14-aastaselt. Seejuures oli e-sigarette elu
              jooksul proovinud 51% poistest ja 59% tüdrukutest, viidates
              laialdasele tarbimisele ning noorte problemaatiliselt kergele
              ligipääsule keelatud toodetele. Uuringuperioodile eelnenud viimase
              kuu jooksul e-sigarette suitsetanute seas oli regulaarseid
              suitsetajaid ehk pea igapäevaseid e-sigarettide tarvitajaid 46%
              ehk iga neljas kooliõpilane, vähemalt korra nädalas suitsetajaid
              27%. Selgus, et enamasti sisaldas e-sigarett nikotiini (89%) ning
              Eestis keelatud lõhna- ja maitseaineid (68%).{" "}
            </p>
          </div>
        </Modal>
      )}
      {modalType === "info3" && (
        <Modal isOpen={isModalOpen} onClose={closeModal} title="">
          <div>
            <p>
              <strong>Seaduslik e-sigarett.</strong>
              <br />
              Eestis on lubatud turustada üksnes nõuetele vastavaid e-sigarette,
              millelt on aktsiis tasutud ning mis on müügil seaduslikes
              müügikanalites.
              <br />
              <br />
              <strong>Eestis kehtivad nõuded:</strong>
              <br />
              1. Lubatud maitseprofiilid: mentool ja tubakas
              <br />
              2. Nikotiinisisaldus kuni 20 mg/ml
              <br />
              3. E-vedeliku maht: kuni 2 ml
              <br />
              4. Märgistatud Eesti maksumärgiga
              <br />
              <br />
              Seaduslik toode on registreeritud ja kontrollitav – mustal turul
              liikuvad tooted võivad olla teadmata päritolu ja sisuga. Lubatud
              toote tunned ära pakendil oleva Eesti maksumärgi järgi.
            </p>
            <img
              src={MaksuMark}
              style={{ width: "130px", margin: "1rem" }}
              alt="Maksumärk"
            />

            <p>Pea meeles: teises riigis seaduslik ≠ Eestis lubatud</p>
          </div>
        </Modal>
      )}

      {modalType === "info4" && (
        <Modal isOpen={isModalOpen} onClose={closeModal} title="">
          <div>
            <p>
              Tulpdiagramm kujutab Maksu- ja Tolliameti (MTA) e-vedelike
              konfiskeerimismahte aastatel 2022–2025. MTA teostab järelevalvet
              ladudes, jaemüügikohtades, maanteedel, postipakkide üle ning
              sotsiaalmeedias. Andmed osutavad tulemusliku järelevalvetöö
              tihenemisele ning konfiskeerimismahtude suurenemisele, millega on
              viidatud aastatel selgelt piiratud e-vedelike ebaseaduslikku
              turustamist.
              <br />
              Numbrid on ümardatud.
            </p>
          </div>
        </Modal>
      )}
      {modalType === "info5" && (
        <Modal isOpen={isModalOpen} onClose={closeModal} title="">
          <div>
            <p>....</p>
          </div>
        </Modal>
      )}
      {modalType === "info6" && (
        <Modal isOpen={isModalOpen} onClose={closeModal} title="">
          <div>
            <p>
              {" "}
              <strong>VASTUTUSTUNDLIKU KAUBANDUSE SUUNISED</strong>
              <br />
              <br />
              1. Müüjaid toetavad nähtavad materjalid müügikohas: „Tubaka- ja
              nikotiinitoodete müük alaealistele on keelatud“. Lisamaterjalid
              teadlikkuse tõstmiseks töötajatele mõeldud ruumides (puhkeruumis
              vms).
              <br />
              <br />
              2. Sagedased ette teatamata omaalgatuslikud kontrollostud
              (minimaalselt kord poolaastas, arvestades hooajalisi töötajaid) ja
              tulemuste sidumine töötasuga.
              <br />
              <br />
              3. Regulaarsed koolitused ja praktilised näpunäited (kord
              kvartalis) alaealistele müümise keelu meelde tuletamiseks.
              <br />
              <br />
              4. Vanusekontrolli teostamine ka visuaalselt nooremale kui
              30-aastasele kliendile.
            </p>
          </div>
        </Modal>
      )}
    </div>
  );
}

export default App;
